import {
  type GetMyOptionsDtoRes,
  userControllerGetMyOptions,
} from "@/shared/api/generated"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

type Store = {
  data: GetMyOptionsDtoRes | null
  setData: (data: GetMyOptionsDtoRes) => void
  invalidateOptions: () => Promise<void>
  reset: () => void
}

export const useOptionsStore = create<Store>()(
  devtools(
    set => ({
      data: null,
      setData: data => set({ data }),
      invalidateOptions: async () => {
        const data = await userControllerGetMyOptions()
        set({ data })
      },
      reset: () => set({ data: null }),
    }),
    { name: "OptionsStore", enabled: process.env.NODE_ENV === "development" }
  )
)
